<template>
  <div>
    <topfind :path="path"></topfind>
            <litable
        :listdata="wordList"
        :col-configs="tablist"
        :page="page"
        >
        <el-table-column slot="opt" label="操作" width="300px">
            <template slot-scope="scope">
                <div class="buttom_c">
                        <el-button size="mini" @click="handleClick(scope.row)">查看</el-button>
                      
                </div>
            </template>  
        </el-table-column>
        </litable>
     
           <el-footer>
<div class="block">
  <el-pagination
  v-if="path==='/启动页查看'||path==='/作文查看'||path==='/优秀作文查看'?false:true"
      @current-change="getather"
      :current-page.sync="currentPage"
      :page-size="pageInputOver"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
</div>
    </el-footer>
  </div>
</template>
<script>
import litable from '@/components/li-table'
import topfind from '@/components/Topmenu'
import testServer from '@/api/management.js'
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
export default {
    components: {
        litable,
        topfind,
       
    },
    data () {
        return {
        path:'',
        pageInputOver:20,
        pageInput:20,
        currentPage:'1' ,
        add:{
          page:''
        }     
        }
    },
    computed:{
        tokenchange(){
      return {
        token: JSON.parse(sessionStorage.getItem('token')).token
        }
    },
        ...mapState( 'managlist', ['wordList','tablist','sClass','total','page','find']),
    },
    methods: {
          ...mapActions('managlist', ['FETCH_CHECKPOINT_LIST','FETCH_WORD_LIST','FETCH_ARTICLE_STAR','FETCH_ARTICLE_LIST','FETCH_STARTUPPAGE_LIST','FETCH_COMPOSITION_LIST','FETCH_AWESOMECOMPOSITION_LIST']),
            handleClick(row){
                     this.$router.push({
                                    name:'文章查看',
                                    query:{
                                        star:row.文章星级,
                                        page: this.add.page
                                    }
                                }) 
            },
          
           getather(val){
             console.log(this.find)
             this.find.page = val
        sessionStorage.setItem('page',val)
       this.FETCH_ARTICLE_STAR(  this.find)
       
    },
    
    },
    async created () {
      this.find = ''
        this.path = this.$route.path
         await this.FETCH_ARTICLE_STAR()
         console.log('什么吗啊啊啊 ')
    }
    
}
</script>
<style lang="scss" scoped>
.el-container{
    height: 100%;
    .block{
    float: right;
}
}

.el-main{
  
   height: 100%;
    overflow: auto;
}

</style>
